var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 88.5167,
    fill: "black",
    fillOpacity: 0.25,
    stroke: "#0016E9",
    strokeWidth: 2.96667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 126C62.2044 126 61.4413 125.684 60.8787 125.121C60.3161 124.559 60 123.796 60 123V57C60.0001 56.4787 60.136 55.9664 60.3944 55.5137C60.6528 55.0609 61.0247 54.6832 61.4735 54.418C61.9222 54.1527 62.4324 54.009 62.9536 54.0009C63.4749 53.9929 63.9892 54.1208 64.446 54.372L124.446 87.372C124.916 87.631 125.309 88.0115 125.582 88.4737C125.855 88.936 125.999 89.4631 125.999 90C125.999 90.537 125.855 91.0641 125.582 91.5263C125.309 91.9886 124.916 92.3691 124.446 92.628L64.446 125.628C64.0031 125.872 63.5056 126 63 126Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPlay);
export default __webpack_public_path__ + "static/media/big-play.21bd9dac617eaa47a6da5b4315b9b8c6.svg";
export { ForwardRef as ReactComponent };